module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAABU0lEQVR4nKWS7VXCMBSGbwJ/0bIBbEAnoG5QNmAC7SYCC4gToBPABuIEdoQe+5fk+qR+0FaqHH3OyUnz5r5vcnNq5J+cHRBlOqH6UlSei4UpkCp+DcAYOXUbUZMIYCistTNCdgKsuwlm7/2WqrE1NkXaO+/WRsz0ddUbspbOgJY54cQ9ctATh96zNg6aQTvJ4Oaw5aS4bg5cZC5TL7cEDNELg/YNTkk5ZUNRzC0ytborF/31IDvMxZs7TEtayCjlgjUwRmHy4lP1mparfoL2GTYm7In9R8xz+eArgMKqZ0WjOJhemGdc82Fw7ZTvK8py1rnUMIyKds8EpsiFEzcK1yYgDjpaA8MIpzdeFqniVM9t2DsGlKtetQ7UzPeY59IB+1XAyKvf87mhhSVvMVWRBZs/mgPUvENISshalf8d2Oi8dh3qjhASMU0YOW+Ryxk0Av7CG+DIuhE8xs3+AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/lianjie.png
// module id = Xgbv
// module chunks = 1